@switch (displayMode()) {

    @case(DisplayMode.FullName)
    {
        <span [id]="room().id">{{ room().fullName()  }}</span>
    }

    @case (DisplayMode.Code) 
    {
        <span [id]="room().id">{{ room().fullCode()  }}</span>
    }

    @case (DisplayMode.Name) 
    {
        <span [id]="room().id">{{ room().name()  }}</span>
    }
    

}


